import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.svg',
    styleUrls: ['./logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {}
